import React from "react";
import { useGlobalSettingsProvider } from "../../../../utilities/global-settings/hooks";
import { Spacings, View } from "react-native-ui-lib";
import { ShiftRootParamList } from "../../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Button, Page, TextField } from "@towersystems/roam-common-native";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { useMutation } from "@apollo/client";
import { MUTATION_EMAIL_CLOSURE_SUMMARY } from "../../../../utilities/terminal-shift/constants";

export type ShiftSendReportModalScreenProps = NativeStackScreenProps<
  ShiftRootParamList,
  "ShiftSendReportModalScreen"
> & {};

export const ShiftSendReportModalScreen = ({
  navigation,
  route,
}: ShiftSendReportModalScreenProps) => {
  const { terminalClosureSendToAddress } = useGlobalSettingsProvider();

  const [input, setInput] = React.useState(terminalClosureSendToAddress || "");
  const shouldFocus = useHasTransitionEnded(navigation);
  const { shiftId } = route.params;

  const [m] = useMutation(MUTATION_EMAIL_CLOSURE_SUMMARY);

  const isValid = React.useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  }, [input]);

  const handleOnSubmit = React.useCallback(() => {
    if (isValid) {
      return m({
        variables: {
          input: {
            closureId: shiftId,
            to: input,
          },
        },
      })
        .then(() => {
          navigation.goBack();
        })
        .catch((err) => console.log(err));
    }
  }, [shiftId, input, isValid]);

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <View style={{ paddingRight: Spacings.s4 }}>
          <Button
            isAction
            size="compact"
            disabled={!isValid}
            onPress={() => handleOnSubmit()}
            label="Send"
          ></Button>
        </View>
      ),
    });
  }, [isValid, handleOnSubmit]);

  const handleOnChangeText = React.useCallback(
    (t: string) => {
      setInput(t);
    },
    [setInput]
  );

  return (
    <Page>
      <View>
        <TextField
          placeholder="Email Address"
          validate={["required", "email"]}
          value={input}
          onChangeText={handleOnChangeText}
          autoFocus={shouldFocus}
        />
      </View>
    </Page>
  );
};
